export const TextUtils = {

    isNullOrWhiteSpace: (value) => {
        return value == null || value.match(/^\s*$/) !== null;
    }

}